/*  检测浏览器方法 */
import useUserStore from '@lcsc-ui/store/user';
import Utils from '@lcsc-ui/utils/Utils';
import Cookies from 'js-cookie';

const getBuriedPointCP = () => {
  const host = location.host;
  const pathname = location.pathname;
  let cp = '';
  if (/www\.szlcsc\.com/.test(host)) {
    cp = 'index';
  } else if (/list\.szlcsc\.com/.test(host)) {
    cp = 'catalog';
    // 区分品牌页
    if (pathname.startsWith('/brand/')) {
      cp = 'brand';
    } else if (pathname.startsWith('/hot')) {
      cp = 'hot_catalog';
    }
  } else if (/so\.szlcsc\.com/.test(host)) {
    cp = 'keyword_search';
    // 区分海外代购页
    if (pathname.startsWith('/overseas/')) {
      cp = 'overseas_list';
    } else if (pathname.startsWith('/mro/')) {
      cp = 'mro_search_box';
    }
  } else if (/item\.szlcsc\.com/.test(host)) {
    cp = 'product_detail';
  } else if (/cart\.szlcsc\.com/.test(host)) {
    cp = 'cart_list';
  } else if (/order\.szlcsc\.com/.test(host)) {
    cp = 'confirm_order';
  } else if (/pay\.szlcsc\.com/.test(host)) {
    cp = 'pay';
  }
  return cp;
};

const params = (obj) => {
  return Object.keys(obj)
    .map((key) => {
      if (Array.isArray(obj[key])) {
        return obj[key].map((arrayValue) => `${encodeURIComponent(key)}=${encodeURIComponent(arrayValue)}`).join('&');
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`;
    })
    .join('&');
};
export const testExternal = (reg) => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (reg.test(userAgent)) {
    return true;
  }
  return false;
};

// 检测手机
export const isPhone = () => {
  return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|MiuiBrowser)/i.test(
    navigator.userAgent
  );
};

export const buriedPoint = (op) => {
  const projectConfigVO = useUserStore.getState().projectConfigVO;
  if (projectConfigVO.lcscCollectorUrl) {
    let noLoginCustomerFlag = Cookies.get('noLoginCustomerFlag');
    if (!noLoginCustomerFlag) {
      noLoginCustomerFlag = Utils.getUuid();
      Cookies.set('noLoginCustomerFlag', noLoginCustomerFlag, {
        domain: '.szlcsc.com',
        expires: 1000 * 60 * 60 * 24 * 30,
        path: '/',
      });
    }

    let noLoginCustomerFlag2 = Cookies.get('noLoginCustomerFlag2');
    if (!noLoginCustomerFlag2) {
      noLoginCustomerFlag2 = Utils.getUuid();
      Cookies.set('noLoginCustomerFlag2', noLoginCustomerFlag2, {
        domain: '.szlcsc.com',
        expires: 1000 * 60 * 60 * 24 * 90,
        path: '/',
      });
    }

    // 公共基础数据
    const data = {
      sid: noLoginCustomerFlag2,
      uid: Cookies.get('isLoginCustomerFlag') || noLoginCustomerFlag,
      pid: Utils.getUuid(),
      referer: Utils.base64Encode(document.referrer),
      cu: Utils.base64Encode(location.href),
      ct: new Date().getTime(),
      pf: 'pc',
    };
    // 搜索重构灰度发布，对照组/实验组
    if (Cookies.get('new_search_group')) {
      data.csl = Cookies.get('new_search_group');
    }
    // 特定数据的提取
    for (const key in op) {
      data[key] = op[key];
    }
    if (!data.cp) {
      data.cp = getBuriedPointCP();
    }
    // cp = keyword_search且存在后端返回的数据时，给data添加数据
    if (data.cp && data.cp === 'keyword_search' && localStorage.getItem('rsLog')) {
      const keywordSearchData = JSON.parse(localStorage.getItem('rsLog'));
      data.data = data.data ? { ...keywordSearchData, ...data.data } : keywordSearchData;
    }
    if (data.data) {
      let strData = data.data;
      if (typeof strData == 'object') {
        strData = JSON.stringify(data.data);
      }
      data.data = Utils.base64Encode(strData);
    }

    let oImag = new Image();
    oImag.src = projectConfigVO.lcscCollectorUrl + '/collect.js?' + params(data);
    oImag = null;
  }
};
